import { LucideIcon } from "lucide-react";

interface Props {
  badge: string;
  icon: LucideIcon;
  title: string;
  subtitle: string;
}

export function BankProductHero({ badge, icon: Icon, title, subtitle }: Props) {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-[hsl(220_60%_15%)] via-[hsl(220_55%_20%)] to-[hsl(220_50%_25%)] py-16 md:py-20">
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.07]"
        style={{
          backgroundImage:
            "linear-gradient(hsl(217 90% 60% / 0.3) 1px, transparent 1px), linear-gradient(90deg, hsl(217 90% 60% / 0.3) 1px, transparent 1px)",
          backgroundSize: "40px 40px",
        }}
      />
      <div className="pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 h-[260px] w-[520px] rounded-full bg-[radial-gradient(ellipse,hsl(217_90%_50%/0.18),transparent_70%)]" />
      <div className="container relative max-w-3xl text-center">
        <div className="mb-4 inline-flex items-center gap-2 rounded-full bg-white/10 px-3 py-1 text-xs font-medium text-blue-100 backdrop-blur-sm border border-white/10">
          <Icon className="h-3.5 w-3.5" />
          {badge}
        </div>
        <h1 className="text-3xl font-extrabold tracking-tight text-white md:text-4xl lg:text-5xl drop-shadow-sm">
          {title}
        </h1>
        <p className="mx-auto mt-4 max-w-2xl text-base leading-relaxed text-blue-100/80 md:text-lg">
          {subtitle}
        </p>
      </div>
    </section>
  );
}
